/*
 * Copyright (c) 2019-2022 LogMeIn
 * All Rights Reserved Worldwide.
 *
 * THIS PROGRAM IS CONFIDENTIAL AND PROPRIETARY TO LOGMEIN
 * AND CONSTITUTES A VALUABLE TRADE SECRET.
 */

import React from 'react';
import { Flex } from '@getgo/chameleon-chakra-ui';
import { AlwaysUseNativeCheckbox } from './AlwaysUseNativeCheckbox';
import { Spacing } from '../../../themes/GoToTheme';
import { GoToText } from '../../Texts/GoToText';

interface Props {
  checkBoxLabel: string;
}

export const GoToAlwaysUseNative: React.FC<Props> = ({ checkBoxLabel }) => {
  const ariaDescribedByLabel = 'checkboxlabel';
  return (
    <Flex marginBottom={Spacing.CoreLayout3}>
      <AlwaysUseNativeCheckbox
        ariaDescribedByLabel={ariaDescribedByLabel}
        size='lg'
      />
      <GoToText id={ariaDescribedByLabel}>{checkBoxLabel}</GoToText>
    </Flex>
  );
};
